import {
    NOTE_SPESE_CONFIG_START,
    NOTE_SPESE_CONFIG_ERROR,
    NOTE_SPESE_CONFIG_SUCCESS,
    NOTE_SPESE_CONFIG_RESET
} from "../../actions/services/note-spese";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export default function noteSpese(state = defaultState, { type, payload, error }) {
    switch (type) {
        case NOTE_SPESE_CONFIG_START:
            return {
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case NOTE_SPESE_CONFIG_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                config: payload
            };
        case NOTE_SPESE_CONFIG_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { code: error.code, message: error.message }
                }
            };
        case NOTE_SPESE_CONFIG_RESET:
            return defaultState;

        default:
            return state;
    }
}
